import { Button, Drawer, Grid, Layout, Menu } from 'antd';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.tsx';
import { useState } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { logout } from '../../lib/firebase.ts';

export const MainLayout = () => {
  const { status } = useAuth();
  const screens = Grid.useBreakpoint();
  const [open, setOpen] = useState(false);
  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);

  const items = [
    {
      key: '/',
      label: (
        <Link to="/" onClick={onClose}>
          ホーム
        </Link>
      ),
    },
    {
      key: '/settings',
      label: (
        <Link to="/settings" onClick={onClose}>
          設定
        </Link>
      ),
    },
    {
      key: '_logout',
      label: 'ログアウト',
      onClick: logout,
    },
  ];

  if (status === 'loading') {
    return <></>;
  }

  if (status === 'unauthenticated') {
    return <Navigate to={'/auth/sign-in'} />;
  }

  return (
    <Layout style={{ height: '100%' }}>
      {screens.md ? (
        <Layout.Sider width={200} theme="light">
          <Menu theme="light" items={items} style={{ flex: 1, minWidth: 0 }} />
        </Layout.Sider>
      ) : (
        <Drawer
          open={open}
          onClose={onClose}
          placement="left"
          size="large"
          styles={{ body: { padding: 0 } }}
        >
          <Menu
            theme="light"
            defaultSelectedKeys={['2']}
            items={items}
            style={{ flex: 1, minWidth: 0 }}
          />
        </Drawer>
      )}
      {screens.md || (
        <Layout.Header
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            padding: '0 20px',
          }}
        >
          <Button icon={<MenuOutlined />} onClick={showDrawer} />
        </Layout.Header>
      )}
      <Layout.Content style={{ overflow: 'auto' }}>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};
